import React, { useCallback, useMemo } from 'react'
import PaymentCelebrationGIF from 'assets/celebration-coin.gif'
import FinisherCelebrationGIF from 'assets/finisher-success.gif'
import { useTranslation } from 'react-i18next'
import { Button } from 'components'

type CelebrationPopupProps = {
    buttonText?: string
    onButtonClick: () => void
    type: 'payment' | 'finisher'
}

export const CelebrationPopupContent = ({
    buttonText,
    onButtonClick,
    type
}: CelebrationPopupProps) => {
    const { t } = useTranslation()

    const pickRandomText = useCallback(() => {
        const randomNumber = Math.floor(Math.random() * 14)
        return t(`motivation.${type}.random`, { returnObjects: true })[
            randomNumber
        ]
    }, [type])

    const randomText = useMemo(() => {
        return pickRandomText()
    }, [type])

    const headerText =
        type === 'payment'
            ? 'motivation.payment.header'
            : 'motivation.finisher.header'

    const image =
        type === 'payment' ? PaymentCelebrationGIF : FinisherCelebrationGIF
    const displayedBtnText =
        buttonText || type === 'payment'
            ? 'motivation.payment.buttonText'
            : 'motivation.finisher.buttonText'

    return (
        <div className="modal--parent">
            <div className="modal--celebration-body">
                <img
                    className="modal--celebration-image"
                    src={image}
                    alt="Popup"
                />
                <h2 className="modal--celebration-header">{t(headerText)}</h2>
                <p className="modal--celebration-text">{randomText}</p>
                <Button
                    className="modal--btn-celebration"
                    onClick={onButtonClick}
                >
                    {t(displayedBtnText)}
                </Button>
            </div>
        </div>
    )
}
